import React, { useEffect } from 'react';

const YandexMetrics: React.FC = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      (function (
        m: any,
        e: Document,
        t: string,
        r: string,
        i: string,
        k?: HTMLScriptElement,
        a?: Element,
      ) {
        if (m[i]) return;
        m[i] = function () {
          (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        k = e.createElement(t) as HTMLScriptElement;
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode!.insertBefore(k, a);
      })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

      // Specific counter for dev.home.quizplease.ru
      window.ym(100285856, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      });
    }
  }, []);

  return null;
};

export { YandexMetrics };
